import { IApplicationDTO } from 'app/shared/services/application.service';
import { License } from 'app/shared/models/license';

export interface IApplication {
  description: string;
  name: string;
}

export class Application {
  description: string;
  name: string;
  licenses: License[] = [];

  constructor(dto?: IApplicationDTO) {
    Object.assign(this, dto);
  }

  clone(): Application {
    const clone = new Application();
    Object.assign(clone, this);
    return clone;
  }
}
